<template>
    <div>
        <section class="container">
            <div class="wrapper">
                <div class="col12 pt-0">
                    <h1 class="page_title">機器レンタルプランのお申し込み</h1>
                    <div class="signup_flow">
                        <ol>
                            <li><span>1</span>ログ <br class="on-sp" />イン</li>
                            <li><span>2</span>申込 <br class="on-sp" />内容</li>
                            <li><span>3</span>情報 <br class="on-sp" />入力</li>
                            <li><span>4</span>支払</li>
                            <li class="current"><span>5</span>完了</li>
                        </ol>
                    </div>
                    <!-- signup_flow -->
                </div>
                <h2 class="col5 section_title">
                    <strong> お申込み承りました </strong>
                </h2>
                <div class="col7 wrap_pr_2col">
                    <div class="pb-2em">契約番号: {{ invoice.subscriptionId }}</div>
                    <p class="big-16 mt-2em mb-2em">
                        お申込み内容は登録いただいたメールアドレスに送信いたしました。<br />
                        契約内容の確認・変更の方法についてもご案内が記載されております。必ずご確認ください。<br />
                        この度はお申込みありがとうございました。<br />
                        商品到着まで今しばらくお待ちください。
                    </p>
                    <p>
                        <a @click="top" href="javascript:void(0)" class="btn_round">サイトTOPへ</a>
                    </p>
                </div>
                <!-- wrap_pr_2col -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
        <Affiliate :affiliatePath="affiliatePath" />
    </div>
</template>

<script>
import Affiliate from "../../../../../../../Affiliate/components/Affiliate.vue";
export default {
    components: {
        Affiliate
    },
    beforeRouteEnter(to, from, next) {
        // 特定の画面以外からの遷移は禁止
        if (from.name !== "ContractConfirm" && from.name !== "Payment") {
            next({ name: "Top" });
            return;
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        if (to.name !== "Top") {
            next(false);
            return;
        }
        next();
    },
    methods: {
        top: function () {
            this.$router.push({
                name: "Top"
            });
        }
    },
    data: function () {
        return {
            invoice: {},
            planName: "",
            affiliatePath: ""
        };
    },
    created() {
        this.invoice = this.$route.params.invoice;
        this.affiliatePath = this.$route.params.affiliatePath;
    }
};
</script>
